<!-- =========================================================================================
  File Name: Customer.vue
  Description: Customer Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Cliente no encontrado" :active.sync="id_not_found">
      <span>Datos de cliente con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'customers'}" class="text-inherit underline"> todos los clientes</router-link>
      </span>
    </vs-alert>

    <vx-card class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <div class="w-full">
              <div class="w-full flex mb-2">
                <div class="w-1/4 mr-4">
                  <ejs-textbox floatLabelType="Auto" placeholder="NIT" :enabled="editing" v-model="data_local.vat"/>
                </div>
                <div class="w-3/4">
                  <ejs-dropdownlist floatLabelType="Auto" placeholder="Tipo de cliente" highlight=true :dataSource="customerTypes" :fields="{text: 'value', value: 'code'}" v-model="data_local.type" :enabled="editing"></ejs-dropdownlist>
                </div>
              </div>
              <div class="w-full flex mb-2">
                <ejs-textbox floatLabelType="Auto" placeholder="Nombre" :enabled="editing" v-model="data_local.name"/>
              </div>
              <div class="w-full flex mb-2">
                <ejs-textbox floatLabelType="Auto" placeholder="Dirección" :enabled="editing" v-model="data_local.address"/>
              </div>
              <div class="w-full flex mb-2">
                <ejs-textbox floatLabelType="Auto" placeholder="Departamento" :enabled="editing" v-model="data_local.state"/>
              </div>
              <div class="w-full flex mb-2">
                <ejs-textbox floatLabelType="Auto" placeholder="Municipio" :enabled="editing" v-model="data_local.city"/>
              </div>
              <div class="w-full flex mb-2">
                <div class="w-1/3 mr-4">
                  <ejs-textbox floatLabelType="Auto" placeholder="Teléfonos" :enabled="editing" v-model="data_local.phones"/>
                </div>
                <div class="w-2/3">
                  <ejs-textbox floatLabelType="Auto" placeholder="Correo electrónico" :enabled="editing" v-model="data_local.email"/>
                </div>
              </div>
              <div class="w-full flex mb-2">
                <div class="w-1/2 mr-4">
                  <ejs-textbox floatLabelType="Auto" placeholder="DPI" :enabled="editing" v-model="data_local.dpi"/>
                </div>
                <div class="w-1/2">
                  <ejs-textbox floatLabelType="Auto" :placeholder="labelExtra1" :enabled="editing" v-model="data_local.extra1" v-show="labelExtra1 != ''"/>
                </div>
              </div>
              <div class="w-full flex mb-2" v-if="labelExtra2 != '' || labelExtra3 != ''">
                <div class="w-1/2 mr-4">
                  <ejs-textbox floatLabelType="Auto" :placeholder="labelExtra2" :enabled="editing" v-model="data_local.extra2" v-show="labelExtra2 != ''"/>
                </div>
                <div class="w-1/2">
                  <ejs-textbox floatLabelType="Auto" :placeholder="labelExtra3" :enabled="editing" v-model="data_local.extra3" v-show="labelExtra3 != ''"/>
                </div>
              </div>
              <div class="w-full flex mb-2" v-if="labelExtra4 != '' || labelExtra5 != ''">
                <div class="w-1/2 mr-4">
                  <ejs-textbox floatLabelType="Auto" :placeholder="labelExtra4" :enabled="editing" v-model="data_local.extra4" v-show="labelExtra4 != ''"/>
                </div>
                <div class="w-1/2">
                  <ejs-textbox floatLabelType="Auto" :placeholder="labelExtra5" :enabled="editing" v-model="data_local.extra5" v-show="labelExtra5 != ''"/>
                </div>
              </div>
              <div class="w-full flex">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Lista de precios" highlight=true :dataSource="priceLists" :fields="{text: 'name', value: 'id'}" v-model="data_local.priceListId" showClearButton=true :enabled="editing"></ejs-dropdownlist>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :multiline="true" :enabled="editing"/>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";

  Vue.use(TextBoxPlugin);
  Vue.use(DropDownListPlugin);

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        data: null,
        parameters: [],
        customerTypes: [],
        priceLists: [],
        data_local: {
          id: 0,
          vat: '',
          name: '',
          address: '',
          state: '',
          city: '',
          phones: '',
          email: '',
          dpi: '',
          extra1: '',
          extra2: '',
          extra3: '',
          extra4: '',
          extra5: '',
          comments: '',
          priceListId: 0,
          priceListName: ''
        },
        id_not_found: false,
        labelExtra1: '',
        labelExtra2: '',
        labelExtra3: '',
        labelExtra4: '',
        labelExtra5: '',
      }
    },
    methods: {
      reset_data() {
        if (this.$route.params.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'customers'});
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            this.$http.post(deltaPOS_config.default.apiURL + '/sale/customers/data', {id: id, context: this.$store.state.AppActiveUser}).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        var message = '';
        if (this.data_local.vat.trim() == '') {
          message = 'Debe indicar un NIT';
        } else if (this.data_local.name.trim() == '') {
          message = 'Debe indicar un nombre';
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error validando información',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de cliente',
            type: 'point'
          });
          var self = this;
          this.data_local.id = this.id;
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/sale/customers/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos del cliente fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'resolution', params: {id: response.data.data.id}});
              }
              this.editing = false;
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar cliente "${this.data.name}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando cliente',
          type: 'point'
        });
        var self = this;
        this.$http.post(deltaPOS_config.default.apiURL + '/sale/customers/delete', {id: this.id, context: this.$store.state.AppActiveUser}).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información eliminada',
              text: 'Datos del cliente fueron eliminados correctamente',
              color: 'primary'
            });
            self.$router.push({name: 'customers'});
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando datos de cliente',
          type: 'point'
        });
      }
      var self = this;
      this.$http
        .post(deltaPOS_config.default.apiURL + '/parameters/list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token})
        .then(response => {
          if (response.data.success) {
            for (var i = 0; i < response.data.data.length; i++) {
              if (response.data.data[i].parameter == 'ORDENES') {
                if (response.data.data[i].code == 'DATOADICIONALCLIENTE1') {
                  this.labelExtra1 = response.data.data[i].value;
                } else if (response.data.data[i].code == 'DATOADICIONALCLIENTE2') {
                  this.labelExtra2 = response.data.data[i].value;
                } else if (response.data.data[i].code == 'DATOADICIONALCLIENTE3') {
                  this.labelExtra3 = response.data.data[i].value;
                } else if (response.data.data[i].code == 'DATOADICIONALCLIENTE4') {
                  this.labelExtra4 = response.data.data[i].value;
                } else if (response.data.data[i].code == 'DATOADICIONALCLIENTE5') {
                  this.labelExtra5 = response.data.data[i].value;
                }
              }
            }
            self.$http
              .post(deltaPOS_config.default.apiURL + '/lists/get_list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token, list: 'TIPOCLIENTE'})
              .then(response => {
                if (response.data.success) {
                  self.customerTypes = response.data.data;
                }
                self.$http
                  .post(deltaPOS_config.default.apiURL + '/sale/price_lists/list', this.$store.state.AppActiveUser)
                  .then(response => {
                    if (response.data.success) {
                      self.priceLists = response.data.data;
                    }
                    self.getData(self.id);
                  });
              });
          }
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>
